module.exports = __webpack_public_path__ + "media/images/redesign-images/textures/texture-3-03c3a237fb26f28b231cc2d2fd9a3f34.svg";